import reportService from '@services/reportService';

export default ({ store }) => {
  if (process.server) return

  const STORAGE_KEY = 'LOG_ERR'
  const MAX_QUEUE = 50
  const FLUSH_INTERVAL = 30000 // 30s

  const originalConsoleError = console.error

  const getQueue = () => {
    try {
      let queue = JSON.parse(localStorage.getItem(STORAGE_KEY)) || []
      if (Array.isArray(queue)) {
        return queue
      }
      return []
    } catch {
      return []
    }
  }

  const saveQueue = (queue) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(queue))
  }

  const pushError = (errorData) => {
    const queue = getQueue()

    if (errorData.type == 'promise' && errorData.message == 'You already started the loading of google maps') return;

    queue.push({
      ...errorData,
      url: location.href,
      date: new Date().toISOString(),
    })

    if (queue.length > MAX_QUEUE) {
      queue.shift() // rotate size
    }

    saveQueue(queue)
  }

  const flushErrors = async () => {
    if (store.state.module != 'design') return

    const queue = getQueue()
    if (!queue.length) return

    const languageUse = store.getters['design/site/languageUse'];
    const pageID = store.getters['design/metadata/sitePage'].properties.metaDataID;

    try {
      reportService.submitReport({
        language: languageUse,
        pageId: pageID,
        message: 'SYSYTEM: Detect error',
        userAgent: navigator.userAgent,
        errors: queue,
      }).then(() => {
        localStorage.removeItem(STORAGE_KEY)
      });
    } catch (e) {
      // if failed, will retry next time
    }
  }



  console.error = function (...args) {
    pushError({
      type: 'console',
      message: args.map(a => String(a)).join(' ')
    })

    originalConsoleError.apply(console, args)
  }

  window.onerror = function (message, source, lineno, colno, error) {
    pushError({
      type: 'window',
      message,
      source,
      lineno,
      colno,
      stack: error ? error.stack : undefined
    })
  }

  window.addEventListener('unhandledrejection', function (event) {
    pushError({
      type: 'promise',
      message: event.reason ? event.reason.message : 'Unhandled Promise Rejection',
      stack: event.reason ? event.reason.stack : undefined
    })
  })


  if (store.state.module == 'design') {
    setInterval(flushErrors, FLUSH_INTERVAL)

    window.addEventListener('beforeunload', flushErrors)
  }
  
}